import { Injectable, signal } from '@angular/core';
import { AdminUserSearchResult } from '../../../../shared/models/admin-user-search-result';

@Injectable()
export class AdminPanelUserPreviewStateService {
  readonly selectedUser = signal<AdminUserSearchResult | null>(null);

  setUser(user: AdminUserSearchResult): void {
    this.selectedUser.set(user);
  }

  clear(): void {
    this.selectedUser.set(null);
  }
}
